// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import config from './lib/config.js'
import lang from './lib/lang.js'
import '../static/css/base.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
//import './vconsole.min.js'

import 'lib-flexible'


// 引入mockjs
//require('./components/mock/mock.js');

Vue.use(config);
Vue.use(lang);

Vue.use(VueAxios,axios);

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js